import React, { useEffect } from "react";
import { useState } from "react";
import Footer from "../../../MyComponents/Footer";
import GuestNav from "../../../MyComponents/Navbars/GuestNav";
import Hero2 from "../../../MyComponents/Hero2";
import FAQS from "../../../MyComponents/FooterPages/newfaq"
import heroContent from "../HeroContent-GDesign";
import leftimg from "../../../assets/canvaleftimg.png";
import rightimg from "../../../assets/canvarightimg.png";
import CourseTimeline from "../../../MyComponents/CourseTimeline";
import Benefits from "../../../MyComponents/Benefits";
import FunActivities from "../../../MyComponents/FunActivities";
import BenefitsDataImg1 from "../../../assets/canva-benefit-img1.png";
import BenefitsDataImg2 from "../../../assets/canva-benefit-img9.png";
import BenefitsDataImg3 from "../../../assets/canva-benefit-img3.png";
import BenefitsDataImg4 from "../../../assets/canva-benefit-img1.png";
import BenefitsDataImg5 from "../../../assets/canva-benefit-img5.png";
import BenefitsDataImg6 from "../../../assets/figma-benefit-img6.png";
import BenefitsDataImg7 from "../../../assets/corel-benefit-img7.png";
import BenefitsDataImg8 from "../../../assets/figma-benefit-img8.png";
import BenefitsDataImg9 from "../../../assets/canva-benefit-img9.png";
import FunactivitiesImg1 from "../../../assets/canvaFun-img1.png";
import FunactivitiesImg2 from "../../../assets/canvaFun-img2.png";
import FunactivitiesImg3 from "../../../assets/canvaFun-img3.png";
import FunactivitiesImg4 from "../../../assets/canvaFun-img4.png";
import FunactivitiesImg5 from "../../../assets/canvaFun-img5.jpg";
import LearningStyle from "../../../MyComponents/LearningStyle"
import VideoSection from "../../../MyComponents/VideoSection";
import Testimonials from "../../../MyComponents/Testimonials";
 const beginnerModules = [
    {
      title: "Module 1",
      activities: "09",
      classes: "08",
      description:" UI/UX Design-  Younger students will learn UI/UX basics, create shapes, templates, and text, design social media posts, and use Whiteboards in Canva..",
    },
    {
      title: "Module 2",
      activities: "09",
      classes: "07",
      description:" UI/UX Design Advanced-  Students learn to design websites, apps, logos, brochures, business cards, and book covers using Canva.",
    }
    
];    

  const benefitsData = [
      {
        title: "Design Basics",
        description: "Core graphic design concepts.",
        icon: BenefitsDataImg1,
      },
      {
        title: "Elements & Principles",
        description: "Balance, contrast, alignment.",
        icon: BenefitsDataImg2,
      },
      {
        title: "CorelDRAW Basics",
        description: "Navigate the interface and essential tools.",
        icon: BenefitsDataImg3,
      },
      {
        title: "CorelDRAW Advanced",
        description: "Work with layers, vectors, and page layouts.",
        icon: BenefitsDataImg4,
      },
      {
        title: "Color Tools",
        description: "Apply color theory and manage palettes efficiently",
        icon: BenefitsDataImg5,
      },
      {
        title: "3D Tables",
        description: "Design detailed tables for print and digital",
        icon: BenefitsDataImg6,
      },
      {
        title: "Object & Effects",
        description: "Add shadows, transparency, and special effects.",
        icon: BenefitsDataImg7,
      },
      {
        title: "Logo Design",
        description: "Craft unique, scalable brand identities.",
        icon: BenefitsDataImg8,
      },
      {
        title: "Certificates & Flex",
        description: "Build impactful, print-ready documents.",
        icon: BenefitsDataImg9,
      },
    ];
    const activitiesData = [
        {
          title: "Business Card",
          image: FunactivitiesImg1,
        },
        {
          title: "Flyers",
          image: FunactivitiesImg2,
        },
        {
          title: "Logos",
          image: FunactivitiesImg3,
        },
        {
          title: "Book Covers",
          image: FunactivitiesImg4,
        },
        {
          title: "Brochures",
          image: FunactivitiesImg5,
        },
      ];
     const videoData = {
    title: "Watch Our Introduction Video",
    description:
      "Discover how kids can turn their creativity into stunning designs! In this video, we’ll introduce fun tools, basic design tips, and exciting projects like logos, flyers, and digital art. Whether you're just starting out or love being creative, this is the perfect place to begin your design journey.",

      
    videoSrc: "", // Replace with the actual video URL
  };
const Canva = () => {
  const Canvapage = heroContent.canvasection;
  return (
    <>
       <GuestNav/>
     <Hero2
        titlePart1={Canvapage.titlePart1}
        // titlePart2={adobepage.titlePart2}
        description={Canvapage.description}
        buttonText={Canvapage.buttonText}
        leftImage={leftimg}
        rightImage={rightimg}
      />
       <CourseTimeline
        title="Course Structure and Syllabus"
        modules={beginnerModules}
      />
       <Benefits
        title="How Students Can Benefit From Abacus"
        benefitsData={benefitsData}
      />
       <FunActivities
              mainTitle="Learn Corel Draw"
              subTitle="With 40+ Fun Activities"
              activities={activitiesData}
            />
        <LearningStyle/>
         <VideoSection
        title={videoData.title}
        description={videoData.description}
        videoSrc={videoData.videoSrc}
      />
      <Testimonials/>
      <FAQS/>
       <Footer/>
    </>
  )
}
export default Canva